export default __webpack_public_path__ + "static/media/12.ef5ef3c5.jpeg";